/*
 * @Author: Czy
 * @Date: 2024-08-19 16:21:39
 * @FilePath: /ayh-mobile-overseas/src/service/user/user.ts
 *
 */
import { http } from '@/utils/http'
import {
  BaseInfoRes,
  UploadParams,
  AuthStatus,
  UserInfoType,
  UserInfoUpdateType,
  TravelCatDiscountDTO,
  LanguageSelectorVo,
} from './user.d'

export type { BaseInfoRes, TravelCatDiscountDTO }

// 小程序登录
export const IdaasLogin = (params: {
  appid?: string
  platform: string
  code?: string
  loginType: string // MINI_PROGRAM登录  MINI_PROGRAM_PHONE_DECRYPT解密手机号
  ubp?: string
  openId?: string
  encryptedPhone?: string
  account?: string
  secret?: string
}) => {
  return http.post<any>('/app/sso/v7/doLogin', params)
}

// 解密手机号
export const DecryptPhoneNumber = (params: { openId: string; code: string }) => {
  return http.post<Result<any>>('/idass/command/miniProgram/wechat/getPhoneNumber', params)
}

// 通过idaasToken获取内部系统的token
export const GetAccessToken = (accessToken: string) => {
  return http.post<Result<any>>(`/common/uaa/auth/login/mini-app`, {
    scope: 'userinfo',
    accessToken,
    appid: import.meta.env.VITE_WX_APPID,
  })
}
// 退出登录
export const Logout = () => {
  // #ifdef H5
  return http.get<Result<any>>('/uaa/auth/logout')
  // #endif
}

// 获取用户信息
export const GetAppUserInfo = () => {
  return http.get<Result<UserInfoType>>('/uaa/auth/userinfo')
}
// 查询授权账号状态信息
export const getAuthStatus = () => {
  return http.get<Result<AuthStatus>>('/query/auxiliary-channel/authorization/callback')
}

// 更新用户信息
export const updateUserInfo = (params: UserInfoUpdateType) => {
  return http.post<Result<boolean>>('/command/travelOwl/update', params)
}

// 查询折扣券列表
export const GetTravelCatDiscount = (params: Page) => {
  return http.post<PageResult<TravelCatDiscountDTO>>(
    '/query/bikecat/travelCatDiscount/page',
    params,
  )
}

// 图片上传
export const getUploadUrl = (params: UploadParams) => {
  return http.get<Result<any>>('/upload/app/infra/platform/file/getputurl', {
    bucketName: 'hx-lynx-loki-log-trunk',
    ...params,
  })
}

//以下 h5 登录专用
// 查询用户是否存在
export const findUser = (params: { phone: string }) => {
  return http.get<Result<boolean>>('/query/user/phone', params)
}
// 获取验证码
export const doSmsCaptchaSend = (params: { pn: string; scene?: string }) => {
  return http.post<Result<any>>('/app/sso/v7/doSmsCaptchaSend', {
    ct: 'customToken',
    scene: params.scene || 'login',
    pn: params.pn,
  })
}
// 验证码登录
export const doSmsLogin = (params: { account: string; secret: string; loginType: string }) => {
  return http.post<Result<any>>('/app/sso/v7/doLogin', params)
}
// 修改密码
export const updatePassword = (params: {
  account: string
  secret: string
  newPassword: string
}) => {
  return http.post<Result<any>>('/app/sso/v7/updatePassword', params)
}
// 验证码注册
export const doRegister = (params: { account: string; secret: string; withLogin?: boolean }) => {
  return http.post<Result<string>>('/app/sso/v7/doRegister', params)
}
// 获取语言列表
export const getLanguageList = () => {
  return http.get<PageResult<LanguageSelectorVo>>('/common/common/language/selector')
}
